import { Container } from "@/components/layout/container";
import { Section } from "@/components/layout/section";
import { PageLayout } from "@/components/layout/page-layout";
import { useClientTranslation } from "@/hooks/use-client-translation";

export default function TermsOfService() {
  const { t } = useClientTranslation();

  return (
    <PageLayout>
      <Section padding="sm">
        <Container>
          <div className="mx-auto max-w-4xl">
          {/* Header */}
          <div className="mb-12 space-y-4">
            <h1 className="text-4xl font-bold tracking-tight md:text-5xl">
              {t("terms.title")}
            </h1>
            <p className="text-lg text-muted-foreground">
              {t("terms.lastUpdated")}
            </p>
          </div>

          {/* Content */}
          <div className="prose prose-gray max-w-none dark:prose-invert">
            {/* Section 1 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t("terms.section1.title")}
              </h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>1.1.</strong>{" "}
                  {t("terms.section1.point1")}
                </p>
                <p>
                  <strong>1.2.</strong>{" "}
                  {t("terms.section1.point2")}
                </p>
                <p>
                  <strong>1.3.</strong>{" "}
                  {t("terms.section1.point3")}
                </p>
              </div>
            </section>

            {/* Section 2 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t("terms.section2.title")}
              </h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>2.1.</strong>{" "}
                  {t("terms.section2.point1")}
                </p>
                <p>
                  <strong>2.2.</strong>{" "}
                  {t("terms.section2.point2")}
                </p>
              </div>
            </section>

            {/* Section 3 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t("terms.section3.title")}
              </h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>3.1.</strong>{" "}
                  {t("terms.section3.point1")}
                </p>
                <p>
                  <strong>3.2.</strong>{" "}
                  {t("terms.section3.point2")}
                </p>
                <p>
                  <strong>3.3.</strong>{" "}
                  {t("terms.section3.point3")}
                </p>
              </div>
            </section>

            {/* Section 4 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t("terms.section4.title")}
              </h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>4.1.</strong>{" "}
                  {t("terms.section4.point1")}
                </p>
                <p>
                  <strong>4.2.</strong>{" "}
                  {t("terms.section4.point2")}
                </p>
              </div>
            </section>

            {/* Section 5 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t("terms.section5.title")}
              </h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>5.1.</strong>{" "}
                  {t("terms.section5.point1")}
                </p>
              </div>
            </section>
          </div>
        </div>
        </Container>
      </Section>
    </PageLayout>
  );
}
